// ---------------------------------------------------------------------------
// process_type = ระบุว่า order ถูกสร้างมาจากระบบหน้าบ้านตัวไหน
//   "zenith_market" = Zenithlink Market (เว็บนี้)
//   "lucid_topup"   = LucidTopup (เติมเกม/เติมเครดิต)
// ใช้ทั้งตอนสร้าง order (transactions/deposits/partner) และตอนกรองประวัติ
// ---------------------------------------------------------------------------
export const PROCESS_TYPE = "zenith_market";

export const PROCESS_TYPE_LABEL = {
  zenith_market: "Zenithlink Market",
  lucid_topup: "LucidTopup",
};

export default PROCESS_TYPE;
